import React from "react";
import ChatPage from "./components/pages/chatPage/ChatPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Signup from "./components/pages/auth/Signup";
import Login from "./components/pages/auth/Login";
import ForgetPassword from "./components/pages/auth/ForgetPassword";
import NotFound from "./components/pages/NotFound";
import { useRecoilValue } from "recoil";
import UserState from "./recoil/UserState";
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import "./AppRouter.css"

const AppRouter: React.FC = () => {

  const user = useRecoilValue(UserState)

  return (
    <Router>
      <Routes>
        <Route path="/signup" element={ 
          <TransitionGroup>
            <CSSTransition
                in
                timeout={500}
                key={1}
                classNames="page"
                unmountOnExit>
              <Signup />
            </CSSTransition>
          </TransitionGroup>
        } />
        <Route path="/forget-password" element={
          <TransitionGroup>
            <CSSTransition
                in
                timeout={500}
                key={2}
                classNames="page"
                unmountOnExit>
              <ForgetPassword />
            </CSSTransition>
          </TransitionGroup>
        } />
        <Route path="/login" element={
          <TransitionGroup>
            <CSSTransition
                in
                timeout={500}
                key={3}
                classNames="page"
                unmountOnExit>
              <Login />
            </CSSTransition>
          </TransitionGroup>
        } />
        {user.isAuthenticated ? (
          <Route path="/" element={
            <TransitionGroup>
              <CSSTransition
                in
                timeout={500}
                key={4}
                classNames="page"
                unmountOnExit>
                <Navigate replace to={`/chat/${uuidv4()}`} />
              </CSSTransition>
            </TransitionGroup>
        } />
        ) : (
          <Route path="/" element={
            <TransitionGroup>
              <CSSTransition
                in
                timeout={500}
                key={5}
                classNames="page"
                unmountOnExit>
                <Navigate replace to="/login" />
              </CSSTransition>
            </TransitionGroup>
        } />
        )
        }
        {user.isAuthenticated ? (
          <Route path="/chat/:session_id" element={
            <TransitionGroup>
              <CSSTransition
                in
                timeout={500}
                key={6}
                classNames="page"
                unmountOnExit>
                <ChatPage />
              </CSSTransition>
            </TransitionGroup>
        } />
        ) : (
          <Route path="/chat/:session_id" element={
            <TransitionGroup>
              <CSSTransition
                in
                timeout={500}
                key={7}
                classNames="page"
                unmountOnExit>
                <Navigate replace to="/login" />
              </CSSTransition>
            </TransitionGroup>
        } />
        )
        }

        <Route path="*" element={
          <TransitionGroup>
              <CSSTransition
                in
                timeout={500}
                key={8}
                classNames="page"
                unmountOnExit>
              <NotFound />
            </CSSTransition>
          </TransitionGroup>
        } />
      </Routes>
    </Router>
  );
}

export default AppRouter;